// Información de build generada automáticamente
export const BUILD_DATE = '13-05-2026 18:39:51';
export const BUILD_HASH = 'as2ukis1t2v';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1778708391449;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '13-05-2026 18:39:51',
  buildHash: 'as2ukis1t2v',
  appVersion: '0.0.0',
  timestamp: 1778708391449
});
